import { Outlet } from 'react-router-dom'
import { useTenantConfig, useCart } from '@webmono/storefront-ui/providers'
import { formatCents } from '@webmono/storefront-ui/utils'
import { Link, useLocation } from 'react-router-dom'

export function StorefrontLayout() {
  const tenant = useTenantConfig()
  const { itemCount, totals } = useCart()
  const location = useLocation()
  const isCartPage = location.pathname === '/cart'
  const isCheckoutPage = location.pathname === '/checkout'

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="sticky top-0 z-50 bg-card border-b border-border safe-top">
        <div className="max-w-lg mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/menu" className="flex items-center gap-3">
            <img
              src={tenant.branding.logo}
              alt={tenant.name}
              className="w-10 h-10 rounded-lg object-cover"
            />
            <div className="hidden sm:block">
              <h1 className="font-heading font-semibold text-foreground leading-tight">
                {tenant.name}
              </h1>
            </div>
          </Link>

          <div className="flex items-center gap-2">
            <Link
              to="/wallet"
              className="p-2 rounded-full text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
              aria-label="My Wallet"
            >
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </Link>

            {!isCartPage && !isCheckoutPage && (
              <Link
                to="/cart"
                className="relative flex items-center gap-2 bg-primary text-primary-foreground px-4 py-2 rounded-full font-medium text-sm transition-transform hover:scale-105 active:scale-95"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
                {itemCount > 0 && (
                  <>
                    <span>{formatCents(totals.subtotalCents, tenant.operations.currency)}</span>
                    <span className="absolute -top-1 -right-1 w-5 h-5 bg-accent text-accent-foreground rounded-full text-xs flex items-center justify-center font-bold">
                      {itemCount}
                    </span>
                  </>
                )}
              </Link>
            )}
          </div>
        </div>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  )
}
